
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/api/charts/line-highlight-element",
      function () {
        return require("private-next-pages/x/api/charts/line-highlight-element.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/api/charts/line-highlight-element"])
      });
    }
  